import { TypographyCaption } from '@heidi/design-system/typography';
import { useIntl } from 'react-intl';
import { getRetrievedFromLabel, type RetrievedFrom } from '../../contracts/retrievedFrom';
import { retrievedFromMessages } from './retrievedFrom.messages';

function RetrievedFromText({ retrievedFrom }: { retrievedFrom: RetrievedFrom }) {
  const intl = useIntl();
  return (
    <TypographyCaption
      className="text-text-tertiary"
      data-testid="citation-retrieved-from"
    >
      {intl.formatMessage(retrievedFromMessages[retrievedFrom])}
    </TypographyCaption>
  );
}

interface RetrievedFromLabelProps {
  retrievedFrom?: string | null;
  /** The list this source sits in has a local source — see `hasLocalRetrieval`. */
  hasLocalSources?: boolean;
  /** Lead with the `·` divider an inline metadata row puts between its items. */
  withDivider?: boolean;
}

/**
 * MOD-1726: quiet provenance sub-label for a source an on-prem appliance
 * retrieved. Renders nothing when the backend did not say where the source came
 * from, which is every cloud citation.
 */
export function RetrievedFromLabel({
  retrievedFrom,
  hasLocalSources = false,
  withDivider = false,
}: RetrievedFromLabelProps) {
  const label = getRetrievedFromLabel(retrievedFrom, hasLocalSources);
  if (!label) return null;
  return (
    <>
      {withDivider && <span aria-hidden="true">·</span>}
      <RetrievedFromText retrievedFrom={label} />
    </>
  );
}
